import React from 'react'

const MySvgIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      fill='none'
      version='1.1'
      width='20'
      height='20'
      viewBox='0 0 20 20'
    >
      <defs>
        <clipPath id='master_svg0_70_5905'>
          <rect x='0' y='0' width='20' height='20' rx='0' />
        </clipPath>
        <pattern
          x='2'
          y='2'
          width='16'
          height='15.849766731262207'
          patternUnits='userSpaceOnUse'
          id='master_svg1_70_5907'
        >
          <image
            x='-7.435043851700129e-7'
            y='0'
            width='16.00000148700877'
            height='15.849766731262207'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANUAAADTCAYAAAAWGVaeAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAguSURBVHic7d1bduNGDEVR2isz0vyHoDF1PnqpbdOUxEehcC9w9m86FlmsQ1BqxflYMNXtdvsT+fPv9/tH5M/He1yAANHhnEVwc7DIF6kGtBehjceCHuQe0TtEdh0LuEP1kF4hsuNYsCc6h/QMge3DIn1DSPsQ12sszkJMVxDYb20XhJDGIq4v7RaCmOJ1D6zNyRPTfF3jKn/SxJSvW1xlT5aYtHQKq9yJEpO2DnGVOkGC8lE5rhInRky+KsZlfULEVEO1sGxPhqDqqRKX3UkQU20VwrI6AYLqwzkumwMnqH5cw5I/aGLqzTEs6QMmKCyLX1iyB0tQWHOJS/IgCQrPOIQldYDEhD3Uw5I5OILCEcphSRyYY1CPi+p47FWohpV+UE6b8tlFdDqHahTDSj0gh82456I5nEdlamGlHYzyRjxzkZTPpwOlsFIORHUDXrkwqufUiUpY0w9CdfONuCCq59aJQlifM19MddMpXAiMobDHpm0mhZPdMjoo1fPsJvNGOWVSqW40JlRdmXtu6uOfkqigCFVHVljhUalOKfSQsf9Co1INimnSy+x9GBZV56CItreQqDoHBU0z92TbDyqiEbCeWWENj4opBWUz9ufQqAhK43WRa1hUqkEBa9F7tfx7quxpkf362BYZ1pCoVKcUGxoZLkelGpQS4tYUtXfLPv6xkbFHRFiXolKdUopBKR4TYpSdVMBeo4fD6aiYUsC2UxtQNahluR7V49yi4lReuy6ib7z/Rf7w2UYFhRqynlrK/H67iN+GxLTyovLoX2pSXcFG96MS0dqhg1LdeJGPfUwrHaoRrTGpIMslorXdB616Z53x4QTTap6skEa+n249qdjUGlRCWv+zs8e1619S3XwzP0JnWo2lGNLa2WNsO6m6buZMDiGt/70zx/w2KtXN5/omdu1+v3+orvEIbiGN0HJSnVnwK8/Y3XQM6TvLqKpt7irTKuO6RK/bmZvpy6gqXOi1K+fEtPqt+1TaYjep2NQaKk6lV6975Hyf/kHVO4HC/5e388frnWL67sh5W00qplQOHvGOsZpUClNqxLG8orTuXafSM3vXY3NSKZ4YU2oeYrqmxS9+ibhgUZsg8+Zxv98/Zr/+7Xb7UymoZTF7T4UYTKZ99n4K+OsPKJ6s0nupNef3VsR03J41Y1I1REyx5CeV8pR6cJlWxDTGu3VkUjVATHP9iEptIRymVKSrX7QlphxMqgHUvmhLTLmIqhBimuPdTfRj/YfjD2kfx0e/rA8siGm+V2v+b1J1XyRXGd+AmPl6jiS/puQ4pSJfe2s9sr5SNPP1XPGeygyPehpeva8iqsGiPgkkJh9yUbk++lXCOl7zuSws4mjO6+l87CrkJtVZbIZrWL9xpD79U/pWwlUum7TifySYTSoqzEVM1zxbvxJRqW4O5eNSPbYKZKKq9OinjJjilfmgAq8R0zwSvxi/+t9NZU5hh/VxtnVtZR7/MB5B5eDxryBiypU+qXj0G8thTapjUgWaGRQx6SCqAPz1QG/pj39nqd6ZCQqpUVXagBn/JS7ybd3cbSeVEoWYFI4Bf1lGpfTox2bGWlpU7ptR8XFP7Xi6spxU2di8eMUuquxHP/Wg1I+vg5S/p3K88I7HjBx2kyoDQeEIonrDMSjHY67EKqrZ76fYnDhjelQOG1Xx4/Kj3I/fmdWkmmH2N8uzP83EeDZRzdh8s4JaxzTz/xaCeDZRRZsZ1IzXQZ6pUSneOWe+f3oVFNOqjs/Oi571uIfaLB7/IjakwnS68meP6HzjzDAtKqULqxgU6rCYVCPNCOrK4x7Tyl+rqGYFFf0a0Cb/25RGbFIe9zBT+UnlGBSPgN6mRJV1MR2Dgr/PZal5B1P/QGLPz474uRWvtRrpx7+zG4sPJJBJOqozKgXFtPIUHtXMC1gpKPgqM6mqBsW08vMvKudFrhoUPMlOqr2bODoohW+YM628yEa1x4ygIn8+agqNKnLTdwuKaeXjR1QuC9wtKHixe/zrHJTyseGLZFTPNk/noCK5PKG4+BWV6gITFFyETaqRERDUFz6w0Cf5+PcdQcHNZlQqdy2C2sa00iY3qR4bhqDgSi6qGb8xtkJQTCtdT6O6srjKF6ZCUNAmN6kiVQuKaaWpTVTVgoKul1FVuWNVDopppaf8pKocFDS9jcr5jtUlqC7n6aLspGKjXed8Q820K6oji6twIQgKmcpNqq5B8YGFjt1ROSxu16CgpcykIiimlYpDUakuLkFBif2kIqifmFb5DkeltLgEBUVDJ5VScJ0xrXKdikphcZlSUGX5noqg3mNa5TkdVdbiEhTUXZpUs8MiqGNYrxw2j39sEB08Ar52OSoWWBs3o/mGTCp++1E/3EyfG/b4F7XIBAU30u+pCGoMPl6fSzYqgoIryagIajym1TySUQHO5KJiSsVhWs0hFRVBoQKZqAhqDqZVPJmogCokomJKzcV6x0qPigtcB4+Af6VGRVB5WPs46ZMKtTCtEqPiTomqmFSN8fF6jLSoui886kqdVISVj2k1XvrjX+fFR00yG5oPLuBqPRjSJ9UDEwtVyES1LISFGqSiWhbCgj/pDcz7LDiQfU+1hakFR9JRLQthwY/VhuVxEIqsHv/WmFpwYBXVshAW9FlvUB4HocD68W+NqQVFZTYlUwtZ1jf3MlE9EBdmK/X4t4VHQmQrvQGZWpih/OPfFuJCpJZRPRAXIrSO6oG4MBJRrRAYriKqJ4gLZxHVDgSGI4jqIALDO0R1AYFhC1ENRGRYFqIKRWQ9EVUCYquNqEwQog++xA0A8PI/4ovNATQm3OYAAAAASUVORK5CYII='
          />
        </pattern>
      </defs>
      <g clipPath='url(#master_svg0_70_5905)'>
        <g>
          <rect
            x='2'
            y='2'
            width='16'
            height='15.849766731262207'
            rx='0'
            fill='url(#master_svg1_70_5907)'
            fillOpacity='1'
          />
        </g>
      </g>
    </svg>
  )
}

export default MySvgIcon
